import i18n from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';
import router from '@/plugins/vue-router';

export class SendersUpdate extends BaseNotification {
  constructor(data) {
    super(data);
  }

  getText() {
    const props = this.getI18nProps();
    const route = { name: 'mailer.sender.index' };
    const link_href = router.resolve(route).href;
    const link_tag = `<a style="color: #fff;" href="${link_href}">${props.text_link}</a>`;
    return `${props.text_body} ${link_tag}`;
  }

  getTheme() {
    const { status } = this.params;

    if (status === 'active') {
      return BaseNotification.THEME_SUCCESS;
    } else if (status === 'canceled') {
      return BaseNotification.THEME_ERROR;
    } else {
      return BaseNotification.THEME_INFO;
    }
  }

  getI18nProps() {
    const { name, status, amount } = this.params;
    const route = { name: 'mailer.sender.index' };

    let text_body = '';

    if (status === 'active') {
      text_body = amount
        ? i18n.t(`notify.notification.senders_update.success_amount`, {
            name,
            amount
          })
        : i18n.t(`notify.notification.senders_update.success`, {
            name
          });
    } else if (status === 'canceled') {
      text_body = i18n.t(`notify.notification.senders_update.error`, {
        name
      });
    } else {
      text_body = i18n.t(`notify.notification.senders_update.body`, {
        name,
        status: i18n.t(`mailer.sender.state.${status}`)
      });
    }

    return {
      text_body,
      path: route,
      text_link: i18n.t(`notify.notification.senders_update.text_link`)
    };
  }
}
